module.exports = __webpack_public_path__ + "img/levelup-logo-accestance-dark.9d26c906.svg";